import { exibirErros } from "componentes/mensagem/actions";

export const ADICIONAR_PROCESSO = "pesquisaprocesso/ADICIONAR_PROCESSO";

export const LISTAR_PROCESSOS = "pesquisaprocesso/LISTAR_PROCESSOS";
export const ADICIONAR_SITUACOES = "pesquisaprocesso/ADICIONAR_SITUACOES";
export const LIMPAR_PESQUISA = "pesquisaprocesso/LIMPAR_PESQUISA";

export const ADICIONAR_RESPONSAVEIS = "pesquisaprocesso/ADICIONAR_RESPONSAVEIS";
export const ADICIONAR_ALEGACOES = "pesquisaprocesso/ADICIONAR_ALEGACOES";
export const ADICIONAR_FASES = "pesquisaprocesso/ADICIONAR_FASES";

export const buscarProcesso = (fase, processo, sei, situacao, responsavel, alegacoes) => dispatch => {
  dispatch({ type: ADICIONAR_PROCESSO, processo: {} });

  var urlProcesso;

  //filtros na tela

  urlProcesso = `/services/api/processos/fases/` + (fase) + `?`;


  if (!!processo) {
    urlProcesso = urlProcesso + "id=" + (processo) + "&";
  }
  if (!!situacao) {
    urlProcesso = urlProcesso + "situacao(descricao)=" + (situacao) + "&";
  }
  if (!!responsavel) {
    urlProcesso = urlProcesso + "usuario(id)=" + (responsavel) + "&";
  }
  if (!!alegacoes) {
    urlProcesso = urlProcesso + "tiposAlegacao=" + (alegacoes) + "&";
  }

  //faz a ordenacao - por id
  const ordenadoPor = "sort=id"
  urlProcesso = urlProcesso + ordenadoPor;

  fetch(urlProcesso)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(processos => {
      dispatch({ type: LISTAR_PROCESSOS, processos });
    })
    .catch(erros => dispatch(exibirErros(erros)));
  dispatch({ type: LIMPAR_PESQUISA });
}


export const adicionarSituacoes = situacoes => dispatch => {
  dispatch({ type: ADICIONAR_SITUACOES, situacoes });
}


export const adicionarResponsaveis = responsaveis => dispatch => {
  dispatch({ type: ADICIONAR_RESPONSAVEIS, responsaveis });
}


export const adicionarAlegacoes = alegacoes => dispatch => {
  dispatch({ type: ADICIONAR_ALEGACOES, alegacoes });
}

export const adicionarFases = fases => dispatch => {
  dispatch({ type: ADICIONAR_FASES, fases });
}

export const buscarSituacoes = () => dispatch => {
  const urlSituacoes = "services/api/situacoes";

  fetch(urlSituacoes)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(situacoes => {
      dispatch({ type: ADICIONAR_SITUACOES, situacoes })
    })
    .catch(erros => dispatch(exibirErros(erros)));
}



export const buscarResponsaveis = () => dispatch => {
  const urlResponsaveis = "services/api/usuarios/responsaveis";

  fetch(urlResponsaveis)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(responsaveis => {
      dispatch({ type: ADICIONAR_RESPONSAVEIS, responsaveis })
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


export const buscarAlegacoes = () => dispatch => {
  const urlAlegacoes = "services/api/tipos-alegacao";

  fetch(urlAlegacoes)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(alegacoes => {
      dispatch({ type: ADICIONAR_ALEGACOES, alegacoes })
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


export const buscarFases = () => dispatch => {
  const urlFases = "services/api/fases";

  fetch(urlFases)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(fases => {
      dispatch({ type: ADICIONAR_FASES, fases })
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


export const limparPesquisa = () => dispatch => {
  dispatch({ type: LIMPAR_PESQUISA })

}


export const carregaAlegacoesFase = (fase) => dispatch => {
  const urlAlegacoes = `/services/api/tipos-alegacao/${fase}/fase`;


  fetch(urlAlegacoes)
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(alegacoes => {
      dispatch({ type: ADICIONAR_ALEGACOES, alegacoes })
    })
    .catch(erros => dispatch(exibirErros(erros)));
}




// WEBPACK FOOTER //
// ./src/paginas/pesquisaprocesso/actions.js